export default "__VITE_ASSET__cUglSgaE__";